import dayjs from "dayjs";
import {
  ALL_EVENTS,
  EVENT_BY_ID,
  EVENT_TYPES,
  INTEGRATION_SUMMARY,
  LOADING,
  NOTIFICATION_SETTINGS,
  PAST_EVENTS,
  UPCOMING_EVENTS,
} from "../actionType/calendarType";
import {
  calendarAuthorize,
  calendarEvents,
  calendarEventTypes,
  calendarIntegrationSummary,
  calenderConnect,
  calenderDisconnect,
  calenderSync,
  notificationSettings,
} from "../constant/Constant";
import {
  deleteAuthMethod,
  getAuthMethod,
  patchAuthMethod,
  postAuthMethod,
  putAuthMethod,
} from "../services/HttpServices";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { getUserInfo } from "../utils/utils";
import axios from "axios";
dayjs.extend(utc);
dayjs.extend(timezone);
const originURL = window.location.origin;
const baseUrl = process.env.REACT_APP_BACKEND_URL;

export const createEvent = (payload) => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: true,
  });
  return postAuthMethod(calendarEvents, payload)
    .then((res) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      return res;
    })
    .catch((err) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      return err;
    });
};

export const updateEvent = (payload) => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: true,
  });

  return putAuthMethod(calendarEvents, payload?.calendarEventId, payload)
    .then((res) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      return res;
    })
    .catch((err) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      return err;
    });
};

export const partialUpdateEvent = (payload) => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: true,
  });

  return patchAuthMethod(calendarEvents, payload?.calendarEventId, payload)
    .then((res) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      return res;
    })
    .catch((err) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      return err;
    });
};

export const getEventTypes = (payload) => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: true,
  });
  return getAuthMethod(calendarEventTypes)
    .then((res) => {
      dispatch({
        type: EVENT_TYPES,
        payload: res?.data,
      });
      dispatch({
        type: LOADING,
        payload: false,
      });
    })
    .catch((err) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      if (!err?.response?.data) return;
      return err;
    });
};

export const deleteEvent = (id) => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: true,
  });
  return deleteAuthMethod(`${calendarEvents}/${id}`)
    .then((res) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      return res;
    })
    .catch((err) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      return err;
    });
};

const userTz = dayjs.tz.guess();

export const getAllEvents = (filters) => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: true,
  });

  const minDate = filters?.minDate
    ? filters?.minDate
    : dayjs().tz(userTz).startOf("month").toISOString();
  const maxDate = filters?.maxDate
    ? filters?.maxDate
    : dayjs().tz(userTz).endOf("month").toISOString();

  let url = `${calendarEvents}?userId.equals=${filters?.userId}`;
  if (minDate) {
    url = `${url}&dueDate.greaterThanOrEqual=${minDate}`;
  }
  if (maxDate) {
    url = `${url}&dueDate.lessThanOrEqual=${maxDate}`;
  }
  if (filters?.keyword) {
    url = `${url}&keyword.contains=${filters?.keyword}`;
  }

  if (filters?.type) {
    url = `${url}&calendarEventTypeId.in=${filters?.type}`;
  }

  return getAuthMethod(url)
    .then((res) => {
      dispatch({
        type: ALL_EVENTS,
        payload: res?.data,
      });
      dispatch({
        type: LOADING,
        payload: false,
      });
      return res?.data;
    })
    .catch((err) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      if (!err?.response?.data) return;
      return err;
    });
};

export const getEventById = (id) => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: true,
  });
  return getAuthMethod(`${calendarEvents}/${id}`)
    .then((res) => {
      dispatch({
        type: EVENT_BY_ID,
        payload: res?.data,
      });
      dispatch({
        type: LOADING,
        payload: false,
      });
    })
    .catch((err) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      if (!err?.response?.data) return;
      return err;
    });
};

export const getUpcomingEvents = (payload) => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: true,
  });
  const minDate = payload?.startDate?.toISOString();
  const maxDate = payload?.endDate?.toISOString();
  const { id: userId } = getUserInfo();
  let url = `${calendarEvents}?userId.equals=${userId}&dueDate.greaterThanOrEqual=${minDate}&dueDate.lessThanOrEqual=${maxDate}`;
  if (payload?.type) {
    url = `${url}&calendarEventTypeId.equals=${payload?.type}`;
  }

  return getAuthMethod(url)
    .then((res) => {
      dispatch({
        type: UPCOMING_EVENTS,
        payload: res?.data,
      });
      dispatch({
        type: LOADING,
        payload: false,
      });
    })
    .catch((err) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      if (!err?.response?.data) return;
      return err;
    });
};

export const getPastEvents = (payload) => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: true,
  });
  const minDate = payload?.startDate?.toISOString();
  const maxDate = payload?.endDate?.toISOString();
  const { id: userId } = getUserInfo();
  let url = `${calendarEvents}?userId.equals=${userId}&dueDate.greaterThanOrEqual=${minDate}&dueDate.lessThanOrEqual=${maxDate}`;
  if (payload?.type) {
    url = `${url}&calendarEventTypeId.equals=${payload?.type}`;
  }
  return getAuthMethod(url)
    .then((res) => {
      dispatch({
        type: PAST_EVENTS,
        payload: res?.data,
      });
      dispatch({
        type: LOADING,
        payload: false,
      });
    })
    .catch((err) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      if (!err?.response?.data) return;
      return err;
    });
};

export const updateNotificationSettings = (payload) => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: true,
  });
  return postAuthMethod(notificationSettings, payload)
    .then((res) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      return res;
    })
    .catch((err) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      return err;
    });
};

export const getNotificationSettings = () => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: true,
  });
  return getAuthMethod(notificationSettings)
    .then((res) => {
      dispatch({
        type: NOTIFICATION_SETTINGS,
        payload: res?.data,
      });
      dispatch({
        type: LOADING,
        payload: false,
      });
    })
    .catch((err) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      if (!err?.response?.data) return;
      return err;
    });
};

export const connectCalendar = (type) => (dispatch) => {
  let method;

  switch (type) {
    case "Google":
      method = `${calenderConnect}?provider=google`;
      break;
    case "Outlook":
      method = `${calenderConnect}?provider=microsoft`;
      break;
    default:
      throw new Error(`Unsupported import type: ${type}`);
  }

  return postAuthMethod(method, { origin: originURL })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const authorizeToCalendar = (payload) => (dispatch) => {
  let method;

  switch (payload?.type) {
    case "Google":
      method = `${calendarAuthorize}/google`;
      break;
    case "Outlook":
      method = `${calendarAuthorize}/microsoft`;
      break;
    default:
      throw new Error(`Unsupported import type: ${payload?.type}`);
  }

  return axios
    .get(`${method}?code=${payload?.code}`, {
      baseURL: baseUrl,
      headers: {
        Authorization: `Bearer ${payload?.token}`,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        origin: originURL,
      },
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const disconnectCalendar = (type) => (dispatch) => {
  let method;

  switch (type) {
    case "Google":
      method = `${calenderDisconnect}/google`;
      break;
    case "Outlook":
      method = `${calenderDisconnect}/microsoft`;
      break;
    default:
      throw new Error(`Unsupported import type: ${type}`);
  }

  return deleteAuthMethod(method)
    .then((res) => res)
    .catch((err) => err);
};

export const syncLatestCalendarEvents = (type) => (dispatch) => {
  let method;

  switch (type) {
    case "Google":
      method = `${calenderSync}/google`;
      break;
    case "Outlook":
      method = `${calenderSync}/microsoft`;
      break;
    default:
      throw new Error(`Unsupported import type: ${type}`);
  }

  return postAuthMethod(method)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const getIntegrationSummary = (payload) => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: true,
  });
  return getAuthMethod(calendarIntegrationSummary)
    .then((res) => {
      dispatch({
        type: INTEGRATION_SUMMARY,
        payload: res.data,
      });
      dispatch({
        type: LOADING,
        payload: false,
      });
    })
    .catch((err) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      if (!err?.response?.data) return;
      return err;
    });
};
